import { useField } from 'formik';
import { FormField, Select, Tooltip } from '@neshane/blueberry';

/**
 * Formik-wrapped Select Component
 */
export const FormikSelect = ({
    label,
    helpText,
    options = [],
    placeholder = 'انتخاب کنید',
    className = '',
    required,
    id,
    disabled,
    tooltip,
    infoTipContent,
    tooltipPlacement = 'top',
    ...props
}) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error;
    const inputId = id || props.name;

    const mappedOptions = options.map((option) => ({
        key: String(option.value),
        label: option.label,
        disabled: option.disabled,
    }));

    const selected = mappedOptions.find((option) => option.key === String(field.value));

    const selectElement = (
        <Select
            id={inputId}
            name={field.name}
            fit="parent"
            placeholder={placeholder}
            isDisabled={disabled}
            isInvalid={hasError}
            options={mappedOptions}
            value={selected}
            onSelect={(option) => helpers.setValue(option.key, true)}
            onBlur={field.onBlur}
        />
    );

    return (
        <FormField
            className={className}
            label={required ? `${label} *` : label}
            htmlFor={inputId}
            description={helpText && !hasError ? helpText : undefined}
            alertMessage={hasError ? meta.error : undefined}
            infoTipContent={infoTipContent}
        >
            {tooltip ? (
                <Tooltip content={tooltip} placement={tooltipPlacement}>
                    <div style={{ width: '100%' }}>{selectElement}</div>
                </Tooltip>
            ) : (
                selectElement
            )}
        </FormField>
    );
};

export default FormikSelect;
